import { Form } from 'antd';

import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import type { DefaultDiscountMode } from '../_components/RoomDiscount/hooks/useRoomDiscountLogic';

type EffectiveRoomDiscountFormValues = {
  defaultDiscountMode?: DefaultDiscountMode;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
};

export const useEffectiveRoomDiscount = (): number | undefined => {
  const form = Form.useFormInstance<EffectiveRoomDiscountFormValues>();
  const discountMode = Form.useWatch('defaultDiscountMode', form) ?? 'CONSTANT';
  const defaultNightRoomDiscount = Form.useWatch(
    'defaultNightRoomDiscount',
    form
  );
  const defaultNightRoomDiscountDays = Form.useWatch(
    'defaultNightRoomDiscountDays',
    form
  );

  if (discountMode === 'DAILY') {
    const dailyValues = Object.values(
      defaultNightRoomDiscountDays ?? {}
    ).filter((value): value is number => value !== null && value !== undefined);

    if (dailyValues.length === 0) {
      return undefined;
    }

    return Math.round(
      dailyValues.reduce((sum, value) => sum + value, 0) / dailyValues.length
    );
  }

  return defaultNightRoomDiscount ?? undefined;
};
